import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { forwardRef, memo, useMemo } from 'react';

const Scrollbar = forwardRef<HTMLDivElement, { children: React.ReactNode; sx?: any }>(
  ({ children, sx }, ref) => {
    const theme = useTheme();

    const scrollbarStyle = useMemo(() => ({
      width: 'auto',
      height: '100%',
      maxHeight: '100vh',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: theme.palette.mode === 'dark' ? '#333' : '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.mode === 'dark' ? '#666666' : '#c0c0c0',
        borderRadius: '10px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: theme.palette.mode === 'dark' ? '#555' : '#999999',
      },
      ...sx,
    }), [theme.palette.mode, sx]);

    return <Box ref={ref} sx={scrollbarStyle}>{children}</Box>;
  }
);

Scrollbar.displayName = 'Scrollbar';

export default memo(Scrollbar);
